// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2363 ? "premiumcarousel.b422bc86" : chunkId) + "--" + {"2363":"e66bbec","5538":"c5faa9b","6082":"3c09e44"}[chunkId] + ".css";
};